/**
 * Include your custom JavaScript here.
 *
 * Hooks do tema:
 * document.addEventListener('variant:changed', function(event) { var variant = event.detail.variant; });
 * document.addEventListener('product:added', function(event) { var variant = event.detail.variant; var quantity = event.detail.quantity; });
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
 *
 * CÃOBUM!: removidos o cálculo automático de "12x" (juros inventados), o código ofuscado que escondia links
 * e redirecionava a ordenação "mais vendidos". O parcelamento agora é configurável em
 * Configurações do tema > CÃOBUM! e fica em assets/caobum.js.
 */

if (window.matchMedia('(max-width: 768px)').matches) {
  window.addEventListener('scroll', function () {
    var pageOffset = document.documentElement.scrollTop || document.body.scrollTop;
    var btn = document.getElementById('scrollToTop');
    if (btn) btn.style.display = pageOffset > 1200 ? 'block' : 'none';
  }, { passive: true });
}
